require('./app');

import 'jquery.maskedinput/src/jquery.maskedinput'

/*!
 * Валидация форм
 */
const ValidationUtil = (() => {
	const validations = {};

	const canSubmit = () => {
		let valid = true;
		try {
			Object.entries(validations).forEach(([k, v]) => {
				if (!v) throw {message: k};
			});
		} catch (e) {
			valid = false;
		}
		if (valid) {
			$('#submit').removeClass('disabled')
				.removeAttr('disabled');

			$('#masterNext').removeClass('disabled')
				.removeAttr('disabled');
		} else {
			$('#submit').addClass('disabled')
				.attr('disabled', 'disabled');

			$('#masterNext').addClass('disabled')
				.attr('disabled', 'disabled');
		}
	};

	const removeErrorMessage = (e, message) => {
		e.removeClass('is-invalid')
			.addClass('custom-input')
			.next('.invalid-feedback')
			.html(message);
	};

	const checkError = (e, value) => {
		if (value) {
			e.removeClass('is-invalid')
				.addClass('custom-input');
		} else {
			e.removeClass('custom-input')
				.addClass('is-invalid');
		}
	};

	const checkBox = (e) => {
		const name = $(e).attr('name');
		return $(`input[name="${name}"]`).is(':checked');
	};

	const email = (e) => {
		// let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		// Более строгая валидация
		let re = /^([a-z0-9\-_\.]{2,})@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test($(e).val());
	};

	const text = (e) => {
		const pattern = $(e).attr('pattern');
		let re = pattern ? new RegExp(pattern) : /^[a-zA-Z0-9_.+-]{2,}$/;
		return re.test($(e).val());
	};

	// TODO реализовать позднее срабатывание валидации на поле "Повторить пароль"
	const password = (e) => {
		let selector = $('input[name^="password"]');
		let auth_form = $('form[class^="auth-form"]');
		let validationMessageSelector = $('#validation-password');
		let oldPasswordSelector = $('#password_old');
		let primaryPasswordSelector = $('#password');
		let confirmPasswordSelector = $('#password_confirmation');
		let errors = {
			password: {
				format: "от 8 и до 14 букв латинского алфавита и/или арабских цифр",
				match: "Пароли должны совпадать"
			}
		};
		if (selector.length > 1 && auth_form.length < 1) {
			if ($(e).attr('name') === 'password') {
				if (primaryPasswordSelector.val().length !== 0 && /^[a-zA-Z0-9]{8,14}$/.test(primaryPasswordSelector.val())) {
					if (confirmPasswordSelector.val().length !== 0 && primaryPasswordSelector.val() === confirmPasswordSelector.val()) {
						confirmPasswordSelector.removeClass('is-invalid');
						validations['password_confirmation'] = true;
						return true;
					} else {
						confirmPasswordSelector.addClass('is-invalid');
						validations['password_confirmation'] = false;
						return true;
					}
				}
			} else if ($(e).attr('name') === 'password_confirmation') {
				return primaryPasswordSelector.val().length !== 0 && primaryPasswordSelector.val() === confirmPasswordSelector.val();
			} else if ($(e).attr('name') === 'password_old') {
				return oldPasswordSelector.val().length !== 0;
			}
		} else  {
			return primaryPasswordSelector.val().length !== 0;
		}
	};

	const select = (e) => {
		return $(e).find(':selected').val() !== 'Выбрать';
	};

	const tel = (e) => {
		// Временно отключено
		// let regex = /\+\d\s\d{3}\s\d{3}-\d{2}-\d{2}/
		// return ($(e).val() !== null && $(e).val() !== '' && regex.test($(e).val()));
		return true;
	};

	const date = (e) => {
		const val = $(e).val();
		if (!val) return false;
		const min = $(e).attr('min');
		const max = $(e).attr('max');
		const valTimestamp = +Date.parse(val);
		const minTimestamp = +Date.parse(min ?? '1900-01-01');
		const maxTimestamp = max ? +Date.parse(max) : Date.getTime();
		return valTimestamp >= minTimestamp && valTimestamp <= maxTimestamp;
	};

	const searchRequired = () => {
		$('[required],[data-validate]').each((i, e) => {
			let name = $(e).attr('name');
			if (!validations.hasOwnProperty(name)) {
				validations[name] = false;
			}
			switch ($(e).attr('type')) {
				case 'checkbox':
				case 'radio':
					if (checkBox(e)) {
						validations[name] = true;
					}
					$(e).on('change', () => {
						validations[name] = checkBox(e);
						canSubmit();
					});
					break;
				case 'email':
					if (email(e)) {
						validations[name] = true;
					}
					$(e).on('keyup change', () => {
						validations[name] = email(e);
						canSubmit();
					});
					break;
				case 'text':
					if (text(e)) {
						validations[name] = true;
					}
					$(e).on('keyup change', () => {
						validations[name] = text(e);
						canSubmit();
					});
					break;
				case 'password':
					if (password(e)) {
						validations[name] = true;
					}
					$(e).on('keyup change', () => {
						validations[name] = password(e);
						canSubmit();
					});
					break;
				case 'select':
					if (select(e)) {
						validations[name] = true;
					}
					$(e).on('change', () => {
						validations[name] = select(e);
						canSubmit();
					});
					break;
				case 'tel':
					if (tel(e)) {
						validations[name] = true;
					}
					$(e).on('keyup change', () => {
						validations[name] = tel(e);
						canSubmit();
					});
					break;
				case 'date':
					if (date(e)) {
						validations[name] = true;
					}
					$(e).on('keyup change', () => {
						validations[name] = date(e);
						canSubmit();
					});
					break;
				default:
					if ($(e).val() !== null && $(e).val() !== '') {
						validations[name] = true;
					}
					$(e).on('keyup change', () => {
						validations[name] = ($(e).val() !== null && $(e).val() !== '');
						canSubmit();
					});
					break;
			}

			canSubmit();

			if (!['checkbox', 'radio'].includes($(e).attr('type'))) {
				$(e).focusout(() => {
					checkError($(e), validations[name]);
				});

				$(e).focusin(() => {
					removeErrorMessage($(e), $(e).next('.invalid-feedback').html());
				});
			}
		});
	};

	const log = (message) => {
		console.log(message);
	};

	return {
		searchRequired,
		canSubmit,
		validations
	}
})();

export default ValidationUtil;
